module.exports = __webpack_public_path__ + "static/media/Niveau_elN5_4_767741.abd452f2.png";